import API from './api';

export const signalsService = {
  getMeta: () => API.get('/api/signals/meta/'),
  getBestPicks: (params = {}) => API.get('/api/signals/best/', { params }),
  getScanner: (params = {}) => API.get('/api/signals/scanner/', { params }),
  getSymbol: (symbol) => API.get(`/api/signals/symbol/${encodeURIComponent(symbol)}/`),
  getSymbolSummary: (symbol) => API.get(`/api/signals/symbol/${encodeURIComponent(symbol)}/summary/`),
  getIndicatorScan: (name, params = {}) => API.get(`/api/signals/indicator/${encodeURIComponent(name)}/`, { params }),
  recompute: (symbol) => API.post(`/api/signals/recompute/${encodeURIComponent(symbol)}/`),
  addSymbol: (symbol) => API.post('/api/signals/add/', { symbol }),
  search: (q, limit = 10) => API.get('/api/signals/search/', { params: { q, limit } }),
};
